import { FC } from "react";
import { Text } from "@otrium/atoms";
import { Flex } from "@otrium/core";
import { Trans } from "@lingui/macro";
import { Lens } from "src/icons/Lens";
import { StyledButton, Styledtitle } from "./NoProductFound.styled";

interface Props {
  onResetFilters?: () => void;
}

const NoProductsFound: FC<Props> = ({ onResetFilters, ...rest }) => {
  return (
    <Flex
      variant="centered"
      height={"400px"}
      {...rest}
      width="100%"
      bg="tone.sand"
      mb={5}
      data-testid="no-products-found"
    >
      <Flex variant="centered" flexDirection="column" width="100%">
        <Lens />
        <Styledtitle mt={3}>
          <Trans>No products found</Trans>
        </Styledtitle>
        <Text
          mb={3}
          mt={2}
          px={4}
          fontSize={1}
          lineHeight={1.5}
          color="tone.black"
          textAlign="center"
        >
          <Trans>
            That’s some nice filter work, but unfortunately we don’t have
            matching products.
          </Trans>
        </Text>
        {onResetFilters && (
          <StyledButton variant="primary" onClick={onResetFilters}>
            <Trans>Reset filters</Trans>
          </StyledButton>
        )}
      </Flex>
    </Flex>
  );
};

export default NoProductsFound;
